export class UserDetailsNew {
    getUserDetails() {
        return {
            query: {
                getUserDetails: {
                    memberDetailsResponse: { member :
                        {
                         upn: true,
                        firstName: true,
                        lastName : true,
                        companyName: true,
                        email : true,
                        mobileNumber: true,
                        image : true,
                        liablePartyId : false,
                        liablePartyName : false,
                        lastSelectedCustomer: false,
                        lastSelectedCarrier: false,
                        carrierId : true,
                        carrierName : true,
                        carrier: true,
                        tractorNumber : true,
                        internalUser: false,
                        customer : false,
                        registered: true,
                        active : true,
                        sendEmailInvite : true,
                        sendSmsInvite: false,
                        updatedTimeStamp: true,
                        createdTimeStamp : false,
                        userLastLogin : false,
                        createdBy : false,
                        updatedBy: true,
                        carrierUsDotNo : true,
                        carrierMcNo : true,
                        tenderingPartyId: false,
                        tenderingPartyName : false,
                        activeCarrier : false,
                        activeCustomer : false,
                         internallyReviewed : false,
                         internallyReviewedBy: false,
                         internallyReviewedAt : false,
                        countryCode : true,
                        userApplicationDetails : { 
                        roles:{ 
                         roleId : true,
                         roleName : true},
                         attributes:
                         { 
                             requestedRoles : true,
                         } 
                        },                        
                        address :{                        
                        addressLine1: true,
                        addressLine2: true,
                        addressType : true, 
                        city: true,
                        state : true,
                        postalCode: true,
                        countryCode: false,
                        },
                        
                        phoneNumberDetails :
                        { number: true,
                        phoneNumberType: true,
                        }},
                        carrierSettings:{
                            carrierInvoiceExists:true,
                        },
                        carrierInfo:
                        { carrierName: true,
                        carrierActiveIndicator: true,
                        source: true,
                         carrierMCNo : true,
                        carrierUsDOTNo: true,
                         commonCarrierId: true,
                         tmsCarrierId : true,
                        carrierScac : true,
                        carrierTier : true,
                        carrierStatusCode: true,
                        addressLine1 : true,
                        addressLine2 : true,
                        city: true,
                         state : true,
                        postalCode: true,
                         carrierModeTruckloadInd: true,
                         carrierModeLTLInd : true,
                        carrierModeIMInd : true,
                        hazmatCertExpirationDate: true,
                        hazmat232PermitInd : true,
                        carrierSponserUserID : true,
                        carrierSponsorProspectUserID : true,
                        primaryContact :{
                         contactFirstName: true,
                        contactLastName: true,
                        contactType: true,
                        contactPhoneNumber: true,
                        contactFaxNumber: true,
                        contactEmail: true,} ,
                        
                        otherContacts :{
                         contactFirstName: true,
                         contactLastName: true,
                         contactType : true,
                         contactPhoneNumber: true,
                         contactFaxNumber: true,
                         contactEmail: true,} ,
                        
                        contacts:{
                         contactFirstName: true,
                         contactLastName: true,
                         contactType: true,
                         contactPhoneNumber: true,
                         contactFaxNumber : true,
                         contactEmail : true,
                         },
                        
                        insurances:{ insuranceId: true,
                         policyNumber: true,
                         maxInsuranceLimit: true,
                         coverageAmount: true,
                         insuranceTypeCode: true,
                         insuranceTypeDesc: true,
                         insuranceStatusCode: true,
                         insuranceCertificateId: true,
                         policyEffectiveDate : true,
                        policyExpirationDate: true,
                        } ,
                        certifications : { 
                        certificationCode: true,
                         certificationDesc: true,
                         certificateExpireDate: true,
                         qualificationStatus : true,},
                        
                         managedEquipmentCapability: true,
                         nonManagedEquipmentCapability: true,
                         carrierContactInfo: 
                        {  carrierPhone : true,
                         carrierName : true,
                         carrierEmail: true,
                          defaultCarrierPhone : true,
                         manageEquipmentPhone : true,
                         nonManageEquipmentPhone: true,
                         displayName: true,
                         jobTitle: true,
                         mobilePhone: true,
                        }
                        }
                    },
                    error: {
                        timestamp: true,
                        status: true,
                        error: true,
                        message: true,
                        path: true,
                    }, userPreference: {
                        id: true,
                        domain: true,
                        upn: true,
                        preferences: {
                            value: true,
                            key: true,
                            domain: true,
                            useractionrequired: true,
                            userPreferenceExists: true,
                        },
                        createdAt: true,
                        createdBy: false,
                        updatedAt: true,
                        updatedBy: true,
                    }
                }
            }
        };
    }
}